import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import OverviewDashboard from '../../../PerksHub/OverviewDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchPerksOverview } from './companyPerksApi';

/**
 * Company Perks → Overview. All four programmes on one page, with each
 * breakdown row opening that programme's own dashboard.
 */
const CPerksOverview = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    () => fetchPerksOverview(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  // Programme key → its tab. Keys come from the backend's overview payload.
  const routeFor = {
    instant_support: `/${slug}/perks/instant-support`,
    salary_sacrifice: `/${slug}/perks/salary-sacrifice`,
    health_scheme: `/${slug}/perks/health-scheme`,
    custom_perks: `/${slug}/perks/custom`
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Perks Overview | Shoorah</title>
      </Helmet>
      <OverviewDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
        onOpenProgramme={(key) => routeFor[key] && navigate(routeFor[key])}
      />
    </div>
  );
};

export default CPerksOverview;
